module.exports = __webpack_public_path__ + "img/truck.4e0659ac.png";